// @flow

import React, { type Node } from 'react';

import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';

import { Margin, Separator } from '../../../../commons/atoms';

import { PagoefectivoCipInformation } from './pagoefectivo-cip-information';
import { PagoefectivoInstructions } from './pagoefectivo-instructions';
import { PagoefectivoTicket } from './pagoefectivo-ticket';
import { SaveAsPdfButton } from './save-as-pdf-button';

export function PagoefectivoPendingPage(): Node {
  const allFeatures = useAllFeatures();

  const margin = '1.6em 0 0 0';

  return (
    <>
      <p>Usa los siguientes datos para completar tu compra:</p>

      <Margin value={margin}>
        <PagoefectivoTicket allFeatures={allFeatures} />
      </Margin>

      <IfFeature allFeatures={allFeatures} wanted="display_pagoefectivo_cip_code">
        <Margin value={margin}>
          <PagoefectivoCipInformation />
        </Margin>
      </IfFeature>

      <Margin value={margin}>
        <Separator pattern="dotted" />
      </Margin>

      <IfFeature allFeatures={allFeatures} wanted="display_pagoefectivo_instructions">
        <Margin value={margin}>
          <PagoefectivoInstructions />
        </Margin>
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="action_pagoefectivo_save_cip_as_pdf">
        <Margin value={margin}>
          <SaveAsPdfButton />
        </Margin>
      </IfFeature>
    </>
  );
}
